import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { arraysEqual } from '../../../utils/array';

interface CheckableProductTag {
  checked?: boolean;
  value: string;
}

@Component({
  selector: 'app-product-tag-checker',
  imports: [MatCheckboxModule, FormsModule],
  templateUrl: './product-tag-checker.html',
  styleUrl: './product-tag-checker.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProductTagChecker),
      multi: true,
    },
  ],
})
export class ProductTagChecker implements ControlValueAccessor {
  value: string[] = [];
  tags: CheckableProductTag[] = [
    {
      checked: false,
      value: 'Train',
    }, {
      checked: false,
      value: 'Stretch'
    }, {
      checked: false,
      value: 'Layer'
    }
  ];
  constructor() { }


  onCheckChanged(
    category: CheckableProductTag,
    parent?: CheckableProductTag,
  ) {
    this.onValueChanged();
  }

  onValueChanged() {
    this.value = [];
    for (const tag of this.tags) {
      if (tag.checked) {
        this.value.push(tag.value);
      }
    }
    this.onChange(this.value);
  }


  updateCategoryChecked() {
    for (const tag of this.tags) {
      tag.checked =
        this.value.length === 0 || this.value.includes(tag.value);
    }
  }

  onChange: (value: string[]) => void = () => { };
  onTouched: () => void = () => { };

  writeValue(value: string[]): void {
    const newValue = value || [];
    if (!arraysEqual(newValue, this.value)) {
      this.value = newValue;
      this.updateCategoryChecked();
    }
  }

  registerOnChange(fn: (value: string[]) => void): void {
    this.onChange = fn; // 注册外部的变更回调
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn; // 注册外部的触摸回调
  }

  disabled: boolean = false;
  // 可选：禁用组件
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
